/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { EdsIconsEnum } from "@cosmos/hygraph-schema";
import type { CosmosIconLinkGroupFragment } from "@cosmos/hygraph-schema";

export const cosmosElementIconLinkGroup: CosmosIconLinkGroupFragment = {
	__typename: "CosmosElementIconLinkGroup",
	id: "icon-link-group-stub",
	description: "Join us on social",
	edsIconLinks: [
		{
			ariaLabel: "Facebook",
			href: "https://facebook.com/epicgames",
			icon: EdsIconsEnum.Facebook,
		},
		{
			ariaLabel: "LinkedIn",
			href: "https://linkedin.com/company/epicgames",
			icon: EdsIconsEnum.LinkedIn,
		},
		{
			ariaLabel: "X",
			href: "https://x.com/epicgames",
			icon: EdsIconsEnum.TwitterX,
		},
		{
			ariaLabel: "Instagram",
			href: "https://instagram.com/epicgames",
			icon: EdsIconsEnum.Instagram,
		},
		{
			ariaLabel: "TikTok",
			href: "https://tiktok.com/@epicgames",
			icon: EdsIconsEnum.TikTok,
		},
	],
};
